var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 11
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#infoIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Zm0-.917a4.583 4.583 0 1 0 0-9.166 4.583 4.583 0 0 0 0 9.166Zm-.458-5.041a.458.458 0 1 1 .916 0V8.25a.458.458 0 1 1-.916 0V5.042Zm.412-1.467a.642.642 0 1 1 0-1.283.642.642 0 0 1 0 1.283Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "infoIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h11v11H0z"
})))));
export default SvgInfoIcon;